<template>
  <div>
    <ShippingHeaderAdd @back="back" :title="$t('sequenciar-transportadora')" />
    <ShippingSequenceTable />
  </div>
</template>
<script>
import ShippingHeaderAdd from "./components/ShippingHeaderAdd.vue";
import ShippingSequenceTable from "./components/ShippingSequenceTable.vue";
import { ShippingIntegrationService } from "@/services/shipping/shipping.integration.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "ShippingSequencePage",
  components: { ShippingHeaderAdd, ShippingSequenceTable },
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    back() {},
    fetch() {
      const vm = this;
      vm.loading = true;
      ShippingIntegrationService.filter('motocycle')
        .then((response) => {
          vm.tableData = response.records.sort((a, b) => a.service.localeCompare(b.service));
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },

};
</script>
